import { render, staticRenderFns } from "./UiTextArea.vue?vue&type=template&id=e9d9f52a&"
import script from "./UiTextArea.vue?vue&type=script&lang=js&"
export * from "./UiTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports